// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { stopAssignment, list, $delete, update, create, get } from "./operations.js";
export type {
  StorageTaskAssignmentsStopAssignmentOptionalParams,
  StorageTaskAssignmentsListOptionalParams,
  StorageTaskAssignmentsDeleteOptionalParams,
  StorageTaskAssignmentsUpdateOptionalParams,
  StorageTaskAssignmentsCreateOptionalParams,
  StorageTaskAssignmentsGetOptionalParams,
} from "./options.js";
